<script setup>
import { trans } from '@elements/translation';
import { EVENT_SLIDERS } from '../../general/event-constants';

const emit = defineEmits([ 'openModal' ]);

const emitClick = () => {
  emit('openModal', {
    title: trans('gestion.invoices.slider.remind'),
    name: EVENT_SLIDERS.PAYMENT_REMINDER,
  });
};
</script>

<template>
  <li @click="emitClick">
    <span>{{ trans('gestion.invoices.remind') }}</span>
  </li>
</template>
